import {Component, Input, OnInit} from '@angular/core';
import {IAbout} from 'projects/paid/src/app/components/about-us/about-us.service';

@Component({
  selector: 'app-about-us-ai-item',
  templateUrl: './about-us-ai-item.component.html',
  styleUrls: ['./about-us-ai-item.component.scss']
})
export class AboutUsAiItemComponent implements OnInit {

@Input()item: IAbout;
  constructor() { }

  ngOnInit(): void {
  }

}
